<template>
  <!-- <div class="userWrap">
    <div class="qrcodecardList">
      <ul>
        <li  v-for="item in docslist" :key="'qr'+item.cardnumber" :id="'qr'+item.cardnumber"   >
          <div class="qrcoderuWrap">
            <img src="./../../assets/img/images/imgT.jpg" class="L imgT" />
            <div class="qrcoderuTop L">
              <h3>{{item.cardname}}</h3>
              <p>{{item.cardnumber}}<br>
              <span :id="'cardticketremaincount'+item.cardnumber">剩余：{{item.cardticketremaincount}} 点</span>
              </p>
            </div>
          </div>
          <div class="qrcodepoWrap" @click="showDetails(item)" v-show="!item.show" >
              <span>查看支付码</span>
          </div>
          <div style="clear:both"></div>
          <div class="qrcodepoWrap1line" v-show="item.show"></div>
          <div class="qrcodepoWrap1" v-show="item.show" @click="showQRcodeDetails(item)" >
             <div class="qrcodepoWrap1img" :id="'qrcode'+item.cardnumber" :ref="'qrcode'+item.cardnumber" ></div>
          </div>
           <div class="qrcodepoWrap1br" style="height:20px;" v-show="item.show"> </div>
           <div class="qrcodepoWrap1clear" style="clear:both;" v-show="item.show"></div>
           <p class="qrcodepoWrap1txt" v-show="item.show" ></p>
        </li>
      </ul>
      <div v-if="docslist.length==0" style="text-align:center"><br><br>{{initmsg}}</div>
      <div class="bottomheight"></div>
    </div>
  </div> -->

  <div class="userWrap">
    <p class="back"><img src="./../../assets/img/images/back_img.png" alt=""><a href="javascript:;" @click="onBackCloseWindow">返回</a></p>
    <div class="qrcodecardList">
      <ul>
        <li  v-for="item in docslist" :key="'qr'+item.cardnumber" :id="'qr'+item.cardnumber"   >
          <div class="qrcoderuWrap">
            <img src="./../../assets/img/images/imgT.jpg" class="L imgT" />
            <div class="qrcoderuTop L">
              <h3>{{item.cardname}}</h3>
              <p>{{item.cardnumber}}<br>
              <span :id="'cardticketremaincount'+item.cardnumber">剩余：{{item.cardticketremaincount}} 点</span>
              </p>
            </div>
          </div>
          <div class="qrcodepoWrap" @click="showDetails(item)">
              <span>查看支付码</span>
          </div>
          <div style="clear:both"></div>
        </li>
      </ul>
      <div v-if="docslist.length==0" style="text-align:center"><br><br>{{initmsg}}</div>
      <div class="mxBg" v-if="ismxBg">
          <div>
            <div>
              <p>线下门店</p>
              <div @click="showQRcodeDetails(item)" id="qrcode" ref="qrcode"></div>
            </div>
            <img src="./../../assets/img/images/close.png" alt="" @click="closeCode">
          </div>
      </div>
      <div class="bottomheight"></div>
    </div>
  </div>
</template>

<script defer=true>

import * as api from "@/api";
import { mapMutations } from "vuex";
import JmmToast from '@/components/JmmToast'
import wx from "weixin-js-sdk";
import QRCode from 'qrcodejs2';

export default {
  name: "wxlogin",
  data() {
    return {
      token: "",
      unionId: "",
      docslist: "",
      cardrights:"",
      merchantid:"",
      appid:"wxc528cd4698883637",
      initmsg:"",
      ismxBg:false,//是否显示二维码弹窗
      merchantId: '',
      stateId: ''
    };
     
  },


  created() {
    this.merchantId = this.$route.query.merchantId;
    this.stateId = this.$route.query.state;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
      this.merchantId = this.stateId;
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else {
      localStorage.setItem('cityMerchantId', "");
    }
    this.token = this.$route.query.token;
    this.unionid = this.$route.query.unionid;
    this.cardrights = this.$route.query.cardrights;
    this.merchantid = this.$route.query.merchantid;
    
  },
  components: {},

  mounted() {
    this.getCode();
  },
  beforeDestroy() {    //页面关闭时清除定时器  
    clearInterval(this.clearTimeSet);
  },
 

  methods: {
    onBackCloseWindow() {
      window.history.go(-2);
    },
    getCode(){ // 非静默授权，第一次有弹框
      this.code = ''
      var local = window.location.href; // 获取页面url
      if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
        // 获取授权后的code位置
        var codeBeg = local.indexOf("?code=");
        var codeEnd = local.indexOf("#/?");
        // 截取授权后的code数据
        var codeCut = local.substring(codeBeg, codeEnd);
        local = local.replace(codeCut, "");
      }
      var appid = this.appid; 
      this.code = this.getUrlCode().code // 截取code
      if (this.code == null || this.code === '' || this.code == undefined) { // 如果没有code，则去请求
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}#wechat_redirect`
      } else {
        var merchantIdState = this.getUrlCode().state // 截取state
        if(null == merchantIdState || undefined == merchantIdState){
          merchantIdState = '';
        }
        if('' == this.merchantId && '' != merchantIdState){
          this.merchantId = merchantIdState;
          localStorage.setItem('cityMerchantId', this.merchantId);
        }
        // 通过code获取信息 
        // JmmToast(this.code);
        this.getList(this.code);  
      }
    },
    getUrlCode() { // 截取url中的code方法
      var url = location.search
      this.winUrl = url
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
          var str = url.substr(1)
          var strs = str.split("&")
          for(var i = 0; i < strs.length; i ++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
      }
      return theRequest
    },
    showQRcodeDetails(e){ //点击二维码刷新二维码
      let _this = this;
      const codeHtml = document.getElementById("qrcode"+e.cardnumber);
      codeHtml.innerHTML = "";
      this.qrcode(e.cardnumber,e.cardid);
    },
    closeCode () { //关闭二维码弹窗
      clearInterval(this.clearTimeSet);
      this.$refs.qrcode.innerHTML = '';
      this.ismxBg = false;
    },
   showDetails(e){ //打开二维码弹窗并获取二维码
      this.ismxBg = true;
      this.$set(e,"class","qrcodepoWrap1height");
      this.$nextTick(() => {
        this.qrcode(e.cardnumber,e.cardid);
      })   
   },
    async  qrcode(cardnumber,cardid) {
      let _this = this;
      try {
        let testToken = "jjcimpilpgejfeehkdinjlbgabbgchhe";
        let testmerchantID="hll";
        let info={
            cardNumber:cardnumber,
            cardId:cardid,
            merchantID:_this.merchantid == undefined ? testmerchantID : _this.merchantid,
          };
          localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
          const { code, data, message } = await api.user.cardqrcode(info);
          if (code == "000000") {  
              //JmmToast(data);
              if(data.code==1){
                  var img = document.createElement('img');
                  img.id = 'qrCodeIco'
                  img.src = data.data.QrCodeImg
                  img.style="width:35px;height:35px; position:absolute; bottom: 0%; left: 0%; right: 0; top: 0; margin: auto; z-index: 100;"
                  document.getElementById('qrcode').appendChild(img)
                  let qrcode = new QRCode('qrcode', {
                    width: 180,
                    height: 180,
                    text: data.data.QrCode, // 需要二维码跳转的地址
                    colorDark : "#000", //前景色
                    colorLight : "#fff", //背景色
                    correctLevel: QRCode.CorrectLevel.H, // 容错率，L/M/H
                  })
                    // document.getElementById(o).style="width: 180px; position: relative;"
                    //更新点数
                    document.getElementById("cardticketremaincount"+cardnumber).innerHTML="剩余："+data.data.QrCodeRemainCount+" 点";
                  //开启定时器
                  this.setTime(cardnumber,cardid,data.data);
              }
          } else {
              HyrToast(submsg || msg)
          }
      }
      catch (err) {
        console.log(err);
      }
    },
    // 获取列表
    async getList(codes) {
      let _this = this;
      try {
        let testToken = "jjcimpilpgejfeehkdinjlbgabbgchhe";
        let testcardRights="40000";
        let testmerchantID="hll";
        let info={
          unionId:"",
          cardRights:_this.cardrights == undefined ? testcardRights : _this.cardrights,
          merchantID:_this.merchantid == undefined ? testmerchantID : _this.merchantid,
          code:codes,
          appID:this.appid

        };
        localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
        const { code, data, message } = await api.user.cardqrcodelistforwxcode(info);
        if (code == "000000") {  
          this.docslist = data;
          if(data.length==0){
            this.initmsg="当前没有卡~";
          }
        } else {
           HyrToast(submsg || msg)
        }
      } catch (err) {
        //JmmToast(err);
        console.log(err);
      }
    },
    setTime(cardnumber,cardid,data){//设置定时器
      this.clearTimeSet = setInterval(() => {
        this.checkqrcodecardinfo(cardnumber,cardid,data);
      }, 3000);
    },
    clearTime(){ //清除定时器
      clearInterval(this.clearTimeSet);
    },
    //卡信息查询
    async checkqrcodecardinfo(cardnumber,cardid,datas){
      let _this = this;
      try {
        let testToken = "jjcimpilpgejfeehkdinjlbgabbgchhe";
          let testmerchantID="hll";
          let info={
            merchantID:_this.merchantid == undefined ? testmerchantID : _this.merchantid,
            code:datas.QrCode
          };
        //JmmToast(localStorage.getItem("qrcodecardnumber"));
          localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
          const { code, data, message } = await api.user.cardgetofflineqrinfo(info);
          if (code == "000000") {  
              //消费码状态 00消费成功 44未使用 03退单 99过期失效
              if(data.data.OrderStatus=="44"){
                //继续查询
              }
              if(data.data.OrderStatus=="00" || data.data.OrderStatus=="99" ){
                //消费成功，弹框
                if(data.data.OrderStatus=="00"){
                  alert("消费成功！");
                }
                //重新生成支付码
                clearInterval(this.clearTimeSet);
                document.getElementById("qrcode").innerHTML = "";
                this.qrcode(cardnumber,cardid);
              }
          } else {
            HyrToast(submsg || msg)
          }
      } catch (err) {
        //JmmToast(err);
        console.log(err);
      }
    }
  },
};
/*export default {
  name: "wxlogin",
  data() {
    return {
      token: "",
      unionId: "",
      docslist: "",
      cardrights:"",
      merchantid:"",
      appid:"wxc528cd4698883637",
      initmsg:"",
    };
     
  },


  created() {
    this.token = this.$route.query.token;
    this.unionid = this.$route.query.unionid;
    this.cardrights = this.$route.query.cardrights;
    this.merchantid = this.$route.query.merchantid;
    
  },
  components: {},

  mounted() {
    
    this.getCode();

    //开启定时器
    this.setTime();

  },
  beforeDestroy() {    //页面关闭时清除定时器  
  clearInterval(this.clearTimeSet);
   },
 

  methods: {


  getCode(){ // 非静默授权，第一次有弹框
    
    this.code = ''
    var local = window.location.href; // 获取页面url
    var appid = this.appid; 
    this.code = this.getUrlCode().code // 截取code
    if (this.code == null || this.code === '') { // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
    } else {
        // 通过code获取信息 
       // JmmToast(this.code);
        this.getList(this.code);
        
    }
  },

  getUrlCode() { // 截取url中的code方法
  var url = location.search
  this.winUrl = url
  var theRequest = new Object()
  if (url.indexOf("?") != -1) {
      var str = url.substr(1)
      var strs = str.split("&")
      for(var i = 0; i < strs.length; i ++) {
          theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
      }
  }
  return theRequest
  },


    showQRcodeDetails(e){
      let _this = this;
       const codeHtml = document.getElementById("qrcode"+e.cardnumber);
             
             codeHtml.innerHTML = "";
       this.qrcode('qrcode'+e.cardnumber,e.cardnumber,e.cardid);
    },

   showDetails(e){
       
       let _this = this;

       const nowStatu=e.show;

       

       //将每一项列表的Show设置为false，让所有的列表隐藏
       this.docslist.forEach(item=>{
           item.show=false

           const codeHtml = document.getElementById("qrcode"+item.cardnumber);
           if(codeHtml != undefined){
              codeHtml.innerHTML = "";
           }
           
           
       })

       //用于再次点击该项是取反的
         e.show=!nowStatu

        
        this.$set(e,"class","qrcodepoWrap1height");
      
        this.qrcode('qrcode'+e.cardnumber,e.cardnumber,e.cardid);
       
   },
       async  qrcode(o,cardnumber,cardid) {
          //JmmToast("更新二维码"+cardnumber+"--"+cardid);
          
          let _this = this;
          try {
            let testToken = "jjcimpilpgejfeehkdinjlbgabbgchhe";
            let testmerchantID="hll";
            let info={
                cardNumber:cardnumber,
                cardId:cardid,
                merchantID:_this.merchantid == undefined ? testmerchantID : _this.merchantid,
              };
              localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
              
              const { code, data, message } = await api.user.cardqrcode(info);

              if (code == "000000") {  
                  //JmmToast(data);
                  if(data.code==1){
                    

                      //过期时间转换为时间戳和当前时间比较 
                      var endDatetmp = data.data.QrCodeDateEnd.replace(/-/g,'/');   
                      var endTimestmp = Date.parse(endDatetmp);    
                      var nowTimestmp=new Date().getTime();
                      
                     

                      //console.log(nowTimestmp+"---"+endTimestmp);

                      //if(nowTimestmp>endTimestmp){
                        //JmmToast("当前二维码已经过期，请重新生成二维码！");
                        //如果不在有效期内，重新生成二维码。
                        //  this.qrcode(o,cardnumber,cardid);
                      //}
                      //else{
                        //如果在有效期内，正常执行
                        //生成二维码
                         //创建图片，插入id为qrcode的div元素中
                          var img = document.createElement('img');
                          img.id = 'qrCodeIco'
                          img.src = data.data.QrCodeImg
                          img.style="width:35px;height:35px; position:absolute; bottom: 0%; left: 0%; right: 0; top: 0; margin: auto; z-index: 100;"
                           document.getElementById(o).appendChild(img)
                        

                      let qrcode = new QRCode(o, {
                          width: 180,
                          height: 180,
                          text: data.data.QrCode, // 需要二维码跳转的地址
                          colorDark : "#000", //前景色
                          colorLight : "#fff", //背景色
                          correctLevel: QRCode.CorrectLevel.H, // 容错率，L/M/H
                        })

                         document.getElementById(o).style="width: 180px; position: relative;"

                         //更新点数
                         document.getElementById("cardticketremaincount"+cardnumber).innerHTML="剩余："+data.data.QrCodeRemainCount+" 点";

                         //存储点击key
                         localStorage.setItem("qrcodekey",o);
                         localStorage.setItem("qrcodecardnumber",cardnumber);
                         localStorage.setItem("qrcodecardid",cardid)
                         localStorage.setItem("qrcodeimgUrl", data.data.QrCodeImg)        // 保存的图片
                         localStorage.setItem("qrcode",data.data.QrCode)
                      //}

                  }
                  
          
              } else {
                  HyrToast(submsg || msg)
              }

             //console.log(code);
             //console.log(data);

          }
          catch (err) {
            console.log(err);
          }

          
          
        },
    // 获取列表
    async getList(o) {
      
      let _this = this;
      try {
            
       
        let testToken = "jjcimpilpgejfeehkdinjlbgabbgchhe";
        let testcardRights="40000";
        let testmerchantID="hll";
        let info={
          unionId:"",
          cardRights:_this.cardrights == undefined ? testcardRights : _this.cardrights,
          merchantID:_this.merchantid == undefined ? testmerchantID : _this.merchantid,
          code:o,
          appID:this.appid

        };
        //JmmToast(localStorage.getItem("qrcodecardnumber"));
        localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
           
        const { code, data, message } = await api.user.cardqrcodelistforwxcode(info);

        if (code == "000000") {  
          
          this.docslist = data;
          if(data.length==0){
            this.initmsg="当前没有卡~";
          }
          this.$nextTick(() => {
            // dom元素更新后执行，因此这里能正确打印更改之后的值
            
            //if(localStorage.getItem("qrcodecardnumber")!= undefined){
             this.initData();
            //}
        })
         
        } else {
           HyrToast(submsg || msg)
        }
        
        
      } catch (err) {
        //JmmToast(err);
        console.log(err);
      }
    },
    
    //初始化上次打开二维码的数据
    initData:function(){
         let _this = this;
         try {
            //JmmToast("0123456789");
            var isshow=false;
            var qrcodecardnumber=localStorage.getItem("qrcodecardnumber");
             this.docslist.forEach(item=>{
           
                if(item.cardnumber==qrcodecardnumber){
                  isshow=true;
                  this.showDetails(item);
                 
                }
           
              })
              //JmmToast(isshow+"aaaaa");
              //如果没有默认展开项目，默认展开第一条
              if(!isshow){
                this.showDetails(this.docslist[0]);
              }
           
         }catch(err){
           console.log(err);
         }

    },
    setTime() //设置定时器
    {
    this.clearTimeSet=setInterval(() => {
      
      var qrcodecardnumber=localStorage.getItem("qrcodecardnumber");
      if(qrcodecardnumber!=undefined){
        if(document.getElementById("cardticketremaincount"+qrcodecardnumber)!=undefined){
          //document.getElementById("cardticketremaincount"+qrcodecardnumber).innerHTML=new Date().toLocaleString();
          //剩余：{{item.cardticketremaincount}} 点
          this.checkqrcodecardinfo(document.getElementById("cardticketremaincount"+qrcodecardnumber));
        }
      }
    }, 3000);
    },
    clearTime() //清除定时器
    {
      clearInterval(this.clearTimeSet);
    },
    //卡信息查询
    async checkqrcodecardinfo(o){
         //o.innerHTML=new Date().toLocaleString();
         //alert("卡已经消费成功！");
         let _this = this;
      try {
           
       var qrcode=localStorage.getItem("qrcode");
          if(qrcode!=undefined){
          let testToken = "jjcimpilpgejfeehkdinjlbgabbgchhe";
          let testmerchantID="hll";
          let info={
            merchantID:_this.merchantid == undefined ? testmerchantID : _this.merchantid,
            code:qrcode
            

          };
        //JmmToast(localStorage.getItem("qrcodecardnumber"));
          localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
           
          const { code, data, message } = await api.user.cardgetofflineqrinfo(info);

          if (code == "000000") {  
            
              //消费码状态 00消费成功 44未使用 03退单 99过期失效
              if(data.data.OrderStatus=="44"){
                //继续查询
              }
              if(data.data.OrderStatus=="00" || data.data.OrderStatus=="99" ){
                //消费成功，弹框
                if(data.data.OrderStatus=="00"){
                  alert("消费成功！");
                }
                //重新生成支付码
                document.getElementById("qrcode"+localStorage.getItem("qrcodecardnumber")).innerHTML = "";
                this.qrcode('qrcode'+localStorage.getItem("qrcodecardnumber"),localStorage.getItem("qrcodecardnumber"),localStorage.getItem("qrcodecardid"));


              }
              
              
              
          
          
          } else {
            HyrToast(submsg || msg)
          }
        }
        
        
        
      } catch (err) {
        //JmmToast(err);
        console.log(err);
      }
    }

    


  },
};*/
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';


.mxBg{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.8);
  >div{
    display: flex;
    flex-direction: column;
    >div{
      width 680px;
      height 904px;
      background: url("./../../assets/img/images/hkBg.png") no-repeat;
      background-size: 100% 100%;
      position relative;
      p{
        padding: 24px;
      }
      #qrcode{
        width 360px;
        height 360px;
        position: absolute;
        top:290px;
        left: 50%;
        transform: translateX(-50%);
        >img{
          width: 100%;
          height 100%;
        }
      }
    }
    >img{
      width 60px;
      height 60px;
      margin: 24px auto 0;
    }
  }

}
.back{
  padding: 20px;
  background: #ccc;
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    width 30px;
    height 30px;
    margin-right: 10px;
  }
  a{
    font-size: 28px;
  }
}
.userWrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f5f5f5;
}

.qrcodecardList {
  width: calc(100% - 40px);
  margin: 20px auto;
}

.qrcodecardList li {
 
  width: 100%;
  min-height :205px;
  height: auto;
  background: url('../../assets/img/images/bgCard.png') no-repeat center center;
  background-size: cover;
  margin: 20px 0;
  color: #fff;
  border-radius: 15px;
  position: relative;

}

.qrcodecardList .qrcoderuWrap {
  width: calc(100% - 40px);
  margin: 0 auto;
}

.qrcodecardList .qrcoderuWrap img {
  width: 100px;
  height: 100px;
  margin-top:60px;
}

.qrcodecardList .qrcodepoWrap {
  width: calc(100% - 60px);
  height: auto;
}

.qrcodecardList .qrcodepoWrap span {

  position: absolute;
  right :30px;
  width :180px;
  height :50px;
  top:100px;
  size :30px;
  font-size :30px;
}


.qrcodecardList .qrcodepoWrap1 {
  width: calc(100% - 60px);
  margin-top:20px;
 
  height: auto;
  position: relative;
}


.qrcodecardList .qrcodepoWrap1img {
width:calc((100% + 60px)*0.60);
margin-left:20%;


}

// 添加logo显示效果
.qrcodepoWrap1img {
  position :relative;
}

.qrcodecardList .qrcodepoWrap1 img {
width:100%;

}



.qrcodecardList .qrcodepoWrap1txt {
    text-align :center;
    width:100%;
}

.qrcodecardList .qrcodepoWrap1line{
     height:1px; 
     width:90%; 
     margin-left:5%; 
     background-color: #fff;
     margin-top:18px;
}

.qrcodecardList .qrcodepoWrap1height{
    height:355px;
}


.qrcodecardList .L {
  float: left;
}

.qrcodecardList .R {
  float: right;
  font-size: 28px;
  line-height: 53px;
  height: 33px;
}

.qrcodecardList .qrcoderuTop {
  padding-top: 50px;
}

.qrcodecardList .qrcoderuTop h3 {
  font-size: 34px;
}

.qrcodecardList .qrcoderuTop p {
  font-size: 28px;
}

.qrcodecardList .imgT {
  margin: 40px 20px 0 20px;
  
}

.qrcodecardList i {
  vertical-align: middle;
  font-size: 18px;
}

.qrcodecardList .bottom {
  position: fixed;
  bottom: 0px;
  background-color: #fff;
  width: 100%;
  height: 80px;
  text-align: center;
}

.qrcodecardList .item1 {
  width: 50%;
  background: #ff1734;
  float: left;
}

.qrcodecardList .item1 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.qrcodecardList .item2 {
  width: 50%;
  background: #999999;
  float: left;
}

.qrcodecardList .item2 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.qrcodecardList .bottomheight {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/wxlogin/index.vue